'use client';

import type React from 'react';
import { useEffect, useMemo, useRef } from 'react';
import { useGTM } from '@/features/Analytics';
import type { PageType } from '@/features/Analytics';
import { GTMParamsManager } from '@/features/Analytics/model/manager';
import { usePathname } from '@/navigation';
type EventProps = Record<string, string | number | boolean>;
interface TrackEventProps extends EventProps {
  eventName: string;
  pageType: PageType;
}
export const TrackEvent: React.FC<TrackEventProps> = ({
  eventName,
  pageType,
  ...customProps
}) => {
  const pathname = usePathname();
  const {
    trackEvent
  } = useGTM(pageType);
  const isInitialMount = useRef(true);
  const eventProps = useMemo(() => {
    const gtm = GTMParamsManager.getInstance();
    const baseParams = gtm.getParams(pageType);
    return {
      pathname,
      ...baseParams,
      ...customProps
    };
  }, [pageType, pathname, customProps]);
  useEffect(() => {
    if (isInitialMount.current) {
      trackEvent(eventName, eventProps);
      isInitialMount.current = false;
    }
  }, [eventName, eventProps, trackEvent]);
  return null;
};